
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import { Dataset, Options } from '../../@types/Slide'
import { ChartOptions } from 'chart.js'

@Component
export default class VerticalBar extends Mixins<Chart>(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'bar'

  /**
   * List of plugins.
   */
  public plugins = [
    {
      beforeUpdate(chart) {
        if (
          (chart.__vueInstance &&
            chart.__vueInstance.$parent.$parent.title.includes('%')) ||
          chart.options.title.text.includes('%') ||
          chart.data.labels.some(label => label.includes('%'))
        ) {
          chart.options.scales.yAxes[0].ticks.min = 0
          chart.options.scales.yAxes[0].ticks.max = 110
          chart.options.__isPercentage = true
        } else {
          const max = Math.max(
            ...chart.data.datasets.map(d => d.data).flat(Infinity)
          )
          chart.options.scales.yAxes[0].ticks.min = 0
          chart.options.scales.yAxes[0].ticks.max = max * 1.5
        }
      }
    }
  ]

  /**
   * Global default options.
   */
  public readonly defaultChartOptions: ChartOptions = {
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: true
          },
          ticks: {
            fontSize: 20,
            maxRotation: 0
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false
          },
          ticks: {
            display: false,
            beginAtZero: true
          }
        }
      ]
    },
    animation: {
      easing: 'linear',
      onProgress(animation) {
        const progress = this._isHovering
          ? 1
          : animation.currentStep / animation.numSteps
        const { chart } = this
        const ctx: CanvasRenderingContext2D = chart.chart.ctx
        const max = Math.max(...chart.data.datasets.map(d => d.data).flat())
        chart.data.datasets.forEach((dataset, datasetIndex, datasets) => {
          if (chart.isDatasetVisible(datasetIndex)) {
            dataset.data.forEach((data, index) => {
              const y =
                chart.scales['y-axis-0'].top +
                chart.scales['y-axis-0'].height +
                (chart.getDatasetMeta(datasetIndex).data[index]._model.y -
                  5 -
                  (chart.scales['y-axis-0'].top +
                    chart.scales['y-axis-0'].height)) *
                  progress

              const x = chart.getDatasetMeta(datasetIndex).data[index]._model.x
              ctx.font = '20px Poppins'
              ctx.fillStyle = dataset.backgroundColor
              ctx.textAlign = 'center'
              ctx.textBaseline = 'bottom'
              let text = (Math.round(data * progress * 10) / 10).toString()
              text += chart.options.__isPercentage ? '%' : ''
              ctx.fillText(text, x, y)
            })
          }
        })
      }
    }
  }
}
